<button (click)="onClick.next()" [disabled]="loading || disabled" [type]="type" class="{{ classList }}">
    <div *ngIf="loading" class="btn-spinner float-left"></div>
    <span *ngIf="!loading || !loadingText" class="btn-label">
		<ng-content></ng-content>
	</span>
    <span *ngIf="loading" class="btn-label">{{ loadingText }}</span>
</button>
